import axios from 'axios';
import { getAuthToken, getPortalType } from '@/utils/auth';
import { API_BASE_URL } from './config';

/**
 * Get authentication headers
 */
const getAuthHeaders = () => {
    const token = getAuthToken(getPortalType(window.location.pathname || ''));
    return {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
    };
};

// Bookmarks API Service
export const bookmarksAPI = {
    // Get all bookmarks for a specific chapter
    // Returns raw list (frontend will group by section)
    getChapterBookmarks: async (chapterId) => {
        try {
            const response = await axios.get(`${API_BASE_URL}/users/bookmarks/`, {
                params: { chapter_id: chapterId },
                headers: getAuthHeaders()
            });
            // Handle pagination if present, though typically we might just want the list
            // For now assuming the view returns a list or UserNotes handling style
            if (response.data && response.data.results) {
                return response.data.results;
            }
            return response.data;
        } catch (error) {
            console.error('Error fetching bookmarks:', error);
            throw error;
        }
    },

    // Create or Update a bookmark
    // Payload: { chapter_id, section_name, section_number, bookmark_type, content_id, content_data }
    createBookmark: async (data) => {
        try {
            const response = await axios.post(
                `${API_BASE_URL}/users/bookmarks/`,
                data,
                { headers: getAuthHeaders() }
            );
            return response.data;
        } catch (error) {
            console.error('Error creating bookmark:', error);
            throw error;
        }
    },

    // Delete a bookmark by ID
    deleteBookmark: async (bookmarkId) => {
        try {
            await axios.delete(
                `${API_BASE_URL}/users/bookmarks/${bookmarkId}/`,
                { headers: getAuthHeaders() }
            );
            return true;
        } catch (error) {
            console.error('Error deleting bookmark:', error);
            throw error;
        }
    }
};
